module.exports = __webpack_public_path__ + "static/img/title.6774c5e5.png";